import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { InactivityTimeoutService } from '../../services/inactivity-timeout.service';

@Component({
  selector: 'app-inactivity-warning',
  standalone: true,
  template: `
    @if (timeout.warningVisible()) {
      <div class="inactivity-overlay" role="presentation">
        <section class="inactivity-dialog" role="alertdialog" aria-modal="true" aria-labelledby="inactivity-title">
          <div class="inactivity-icon" aria-hidden="true">!</div>
          <p id="inactivity-title">Due to inactivity, your session will end in:</p>
          <p class="inactivity-countdown">{{ formatTime(timeout.remainingSeconds()) }}</p>
          <p class="inactivity-message">Your progress will be lost if your session ends or if you close your browser.</p>
          <button type="button" class="inactivity-continue" (click)="timeout.continueApplication()">
            Continue My Application
          </button>
        </section>
      </div>
    }
  `,
  styleUrls: ['./inactivity-warning.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InactivityWarningComponent {
  readonly timeout = inject(InactivityTimeoutService);

  formatTime(totalSeconds: number): string {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes} min ${seconds} seconds`;
  }
}